module.exports = __webpack_public_path__ + "img/mapa_es (2).f5f432e6.jpg";